import {
  get,
  post,
  postForm,
  put,
  del
} from '../service/request'

// 自定义用户注册
export const registerUserApi = (p) => post('auth/registerUser', p)
// 发送邮箱验证码
export const sendMailCodeApi = (p) => post('auth/mailCode/send', p)

// 登录
export const signIn = (p) => post('auth/user/sign_in', p)
// 获取用户信息
export const getInfo = (p) => get('auth/authUser/' + p.userId, p)
// 退出登录
export const logOut = (p) => postForm('auth/user/logout')
// 获取用户列表
export const getUserListApi = (p) => get('auth/authUser', p)
// 修改用户状态
export const setUserStatusApi = (p) => put('auth/authUser/' + p.userId + "/status", p)
// 添加用户权限
export const addUserRoleApi = (p) => post('auth/authRoles', p)
// 删除用户权限
export const deleteUserRoleApi = (p) => del('auth/authRoles/' + p.userId + '/' + p.roleId, p)
// 修改用户信息
export const editUserApi = (p) => put('auth/authUser/' + p.userId, p)
// 新增用户
export const addUserApi = (p) => post('auth/authUser/add', p)

// 修改密码
export const resetPwdApi = (p) => post('auth/user/password/change', p)
// 管理员修改密码
export const resetPwdByAdminApi = (p) => post('auth/user/password/reset', p)

// 获取角色列表
export const getRoleListApi = (p) => get('auth/authRoles', p)


// WEBPACK FOOTER //
// ./src/service/user.js